import { Stack, Text } from "@mantine/core";

export const CPD_SCORE_FIELDS = [
  { key: "IACredit", label: "IA" },
  { key: "IAERCredit", label: "IAER" },
  { key: "IAROCredit", label: "IA RO" },
  { key: "IAILASCredit", label: "ILAS" },
  { key: "MPFCoreCredit", label: "MPF Core" },
  { key: "MPFNonCoreCredit", label: "MPF Non-Core" },
  { key: "SFCCredit", label: "SFC" },
  { key: "SFCECCredit", label: "SFC EC" },
];

export const renderCpdScoresCell = (col, data) => {
  const lines = CPD_SCORE_FIELDS.filter(
    ({ key }) => (data[key] ?? 0) > 0
  ).map(({ key, label }) => (
    <Text key={key} size="xs">
      {label}: {data[key]}
    </Text>
  ));

  if (!lines.length) {
    return (
      <Text size="xs" color="dimmed">
        —
      </Text>
    );
  }

  return <Stack spacing={2}>{lines}</Stack>;
};
